var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCandidateSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2849_765",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2849_765)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 21.15L9.5498 18.7H5.7998C5.36647 18.7 5.00814 18.5584 4.7248 18.275C4.44147 17.9917 4.2998 17.6334 4.2998 17.2V4.80005C4.2998 4.36672 4.44147 4.00838 4.7248 3.72505C5.00814 3.44172 5.36647 3.30005 5.7998 3.30005H18.1998C18.6331 3.30005 18.9915 3.44172 19.2748 3.72505C19.5581 4.00838 19.6998 4.36672 19.6998 4.80005V17.2C19.6998 17.6334 19.5581 17.9917 19.2748 18.275C18.9915 18.5584 18.6331 18.7 18.1998 18.7H14.4498L11.9998 21.15ZM11.9998 12.1C12.7998 12.1 13.4748 11.825 14.0248 11.275C14.5748 10.725 14.8498 10.05 14.8498 9.25005C14.8498 8.45005 14.5748 7.77505 14.0248 7.22505C13.4748 6.67505 12.7998 6.40005 11.9998 6.40005C11.1998 6.40005 10.5248 6.67505 9.9748 7.22505C9.4248 7.77505 9.1498 8.45005 9.1498 9.25005C9.1498 10.05 9.4248 10.725 9.9748 11.275C10.5248 11.825 11.1998 12.1 11.9998 12.1ZM5.5498 18H18.4498C18.6331 17.9 18.7581 17.8042 18.8248 17.7125C18.8915 17.6209 18.9498 17.5 18.9998 17.35C18.0998 16.4667 17.054 15.7709 15.8623 15.2625C14.6706 14.7542 13.3831 14.5 11.9998 14.5C10.6165 14.5 9.32897 14.7542 8.1373 15.2625C6.94564 15.7709 5.8998 16.4667 4.9998 17.35C5.0498 17.5 5.10814 17.6209 5.1748 17.7125C5.24147 17.8042 5.36647 17.9 5.5498 18Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCandidateSvg);
export default __webpack_public_path__ + "static/media/candidateSvg.aba7708e4fe9cd611fa3d7a5ff9edfee.svg";
export { ForwardRef as ReactComponent };